// import Fm from 'feathers-memory'
// import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

export { default as validate } from './validate'
export { default as queryObject } from './query'

// Type Casters
export const castArray = arr =>
  (typeof arr !== 'object' || typeof arr.length === 'undefined') ? [arr] : arr
export const toNumber = val => Number(val)
export const toDecimal = val => Number(val.toFixed(2))
export const int = num => parseInt(num, 10)
export const float = num => parseFloat(num, 10)

// Type Checkers
export const isPlainObject = val => val !== null && typeof val === 'object' && !Array.isArray(val)
export const isArray = val => Array.isArray(val)
export const isNumeric = val => !isNaN(int(val))
export const isNumber = val => typeof val === 'number'
export const isString = val => typeof val === 'string'
export const isFunction = val => typeof val === 'function'
export const isError = val =>
  isPlainObject(val) && (val instanceof Error || (val.error && val.code))
// export const isPromise = val => typeof val === 'object' && (val instanceof Promise)
export const isDate = val => val instanceof Date && !isNaN(val.valueOf())
export const isDateish = val => isDate(val) ||
  (typeof val === 'string' &&
    (val.length === 10 || val.length === 24 || val.length === 29) &&
    val.split('-').length === 3 &&
    !isNaN(Date.parse(val)))
export const isJSONString = (val) => {
  try {
    JSON.parse(val)
  } catch (e) {
    return false
  }
  return true
}

// Shorthands
export const count = obj => Object.keys(obj).length
export const empty = obj => !count(obj)
export const error = err => typeof Error === 'function' ? new Error(err) : err
export const resolution = res => Promise.resolve(res)
export const rejection = err => Promise.reject(error(err))
export const homeUrl = window.location.origin

// Iterators
export const forEach = (obj, callback) =>
  Object.keys(obj).forEach(key => callback(obj[key], key))

// Array.reduce applied to objects
export const reduce = (obj, callback, aggregator = {}) =>
  Object.keys(obj).reduce((acc, key, index) =>
    callback(acc, obj[key], key, index), aggregator)

// Array.map applied to objects + filters out undefined values
export const map = (obj, callback) =>
  reduce(obj, (acc, element, key, index) => {
    const res = callback(element, key, index)

    if (res !== undefined) {
      acc[key] = res
    }

    return acc
  }, {})

// Array.filter applied to objects
export const filter = (obj, callback) =>
  map(obj, (element, key, index) => callback(element, key, index) ? element : undefined)

export const findIndex = (objs, key, value) => {
  const filtered = Object.keys(objs).filter(val => val[key] === value)
  return filtered.length === 0 ? -1 : filtered[0]
}

// --------- Booleans ---------
// const buildEnumListMap = possibleValues => possibleValues
//   .map((key, index) => [
//     key,
//     Math.pow(2, index),
//   ])
//   .reverse()

// export const integerToEnumList = (possibleValues) => {
//   const valueMap = buildEnumListMap(possibleValues)

//   return integer => valueMap
//     .filter(([_, value]) => {
//       if (value > integer) return false

//       integer -= value

//       return true
//     })
//     .map(([key]) => key)
// }

// export const enumListToInteger = (possibleValues) => {
//   const valueMap = buildEnumListMap(possibleValues)

//   return enumList => valueMap
//     .filter(([key]) => enumList.includes(key))
//     .map(([_, value]) => value)
//     .reduce(toSum)
// }

// export const boolObjectToInteger = (possibleValues) => {
//   const reduceEnumListToInteger = enumListToInteger(possibleValues)

//   return (boolObj) => {
//     const enumList = Object
//       .keys(boolObj)
//       .filter(key => possibleValues.includes(key) && boolObj[key])

//     return reduceEnumListToInteger(enumList)
//   }
// }

// export const integerToBoolObject = (possibleValues) => {
//   const valueMap = buildEnumListMap(possibleValues)
//   const objTemplate = valueMap
//     .reduce((acc, [key]) => ({
//       ...acc,
//       [key]: false,
//     }), {})

//   return (integer) => {
//     const objCopy = { ...objTemplate }

//     valueMap
//       .forEach(([key, value]) => {
//         if (value < integer) {
//           integer -= value
//           objCopy[key] = true
//         }
//       })

//     return objCopy
//   }
// }

// --------- Strings ---------
const splitByCapital = str => str.split(/(?=[A-Z])/)
export const toHtmlAttributeName = str => splitByCapital(str).join('-').toLowerCase()
export const slugify = str => str ? str.toLowerCase().replace(/ /g, '-') : ''

// ---- Data Management ----
export const getters = (...arr) => mapGetters([
  '_user',
  'isAuth',
  'hasPermissions',
  'hasRoles',
  'loaded',
  'query',
  ...arr
])
export const actions = (...arr) => mapActions([
  // loaders
  'LOAD',
  'LOADED',

  // error reporting
  'ERROR',

  // alerts
  'ALERT',
  'DANGER',
  'SUCCESS',

  // confirmation alerts
  'CONFIRM',

  // Analytics events
  'GEVENT',

  // DOM event binding
  'ON',
  'OFF',
  ...arr,
])

// export const filter$ = params => filter(params, (val, key) => key[0] === '$')
// export const filterOut$ = params => filter(params, (val, key) => key[0] !== '$')

// const formatQuery = (query) => {
//   forEach(query, (value, key) => {
//     if (key.indexOf('Id') === (key.length - 3) && !isPlainObject(value)) {
//       query[key] = int(value)
//     }
//   })

//   return filterOut$(query)
// }

// type reducing
export const fromObject = obj => (acc, key) => {
  acc[key] = obj[key]
  return acc
}

// export const pullKeys = (...keys) => obj => keys.reduce(fromObject(obj), {})

// const serverQuery = (query) => {
//   const { $fetch, $server, ...cleanQuery } = query
//   Object.assign(cleanQuery, $server)
//   return Object.keys(cleanQuery).reduce((acc, key) => {
//     const condition = cleanQuery[key]
//     if (isPlainObject(condition) && typeof condition.value !== 'undefined') {
//       if (condition.value !== null || !condition.$ignore) {
//         if (condition.$compare === 'like') {
//           acc[key] = { $like: `%${condition.value}%` }
//         } else {
//           acc[key] = condition.value
//         }
//       }
//     } else {
//       acc[key] = condition
//     }
//     return acc
//   }, {})
// }

// --------- Services ---------
export const isProduction = window.location.host === 'www.jobcarda.com' &&
  process.env.NODE_ENV === 'production'

export const getServiceName = mod => mod.serviceName || mod.name.toLowerCase()

// --------- State ---------
export const stateList = state =>
  typeof state.list !== 'undefined'
    ? state.list
    : state

// export const stateGetters = (...list) => list.reduce((acc, key) => ({
//   ...acc,
//   [key]: state => state[key],
// }), {})

// export const exposeState = state => stateGetters(...Object.keys(state))

const pushOptions = (options, nullAs) => {
  if (nullAs) {
    options.push(nullAs)
  }

  // fix null typecast to string
  return options.map(([head, ...tail]) => head === 'null' ? [null, ...tail] : [head, ...tail])
}

export const autoFormOptions = key => (state, gettrs) => gettrs[`form${key}Options`](state)

export const formOptions = ({ key = 'id', value = 'name', nullAs = [null, 'N/A', 'All'] } = {}) =>
  state =>
    pushOptions(Object.values(stateList(state))
      .map(obj => [
        obj[key],
        ...castArray(isFunction(value) ? value(obj) : obj[value]),
      ]), nullAs)
    // .sort(SORT.by(1))

export const preformOptions = options => () => formOptions(options)

export const statusOptions = (name, { nullAs = [null, 'All'] } = {}) => (_, gettrs) =>
  pushOptions(Object
    .keys(gettrs[name])
    .map(opt => [opt, gettrs[name][opt].name]),
  nullAs)

export const gen = obj => () => (overrides = {}) => {
  if (typeof obj === 'function') {
    return { ...obj(), ...overrides }
  }
  return {
    ...obj,
    ...overrides,
  }
}

// --------- Random ---------

const randomString = (length = 24) => {
  const s = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  return Array(length)
    .join()
    .split(',')
    .map(() =>
      s.charAt(Math.floor(Math.random() * s.length)))
    .join('')
}
export const genId = () => randomString(8)

export const randomInRange = (min, max) => Math.floor((Math.random() * ((max - min) + 1)) + min)
export const randomIndex = arr => randomInRange(0, arr.length - 1)
export const randomInArray = arr => arr[randomIndex(arr)]

export const stripFields = (obj, fields) =>
  Object
    .keys(obj)
    .filter(field => !fields.includes(field))
    .reduce(fromObject(obj), {})

// export const SORT = {
//   asc: (key = 'id') => (a, b) => b[key] - a[key],
//   desc: (key = 'id') => (a, b) => a[key] - b[key],
// }

// --------- Strings ---------
export const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1)
export const pad = (str, len = 2, char = '0') => {
  if (typeof str !== 'string') {
    str = str.toString()
  }

  while (str.length < len) {
    str = char + str
  }

  return str
}

// --------- Objects ---------
// const values = obj => Object.values(obj)
// const sum = arr => arr.reduce((a, b) => a + b, 0)
// export const average = arr => sum(arr) / arr.length

// TODO: does not clone arrays, which can be cloned similarly as child objects
export const toClone = (obj) => {
  const clone = { ...obj }

  Object
    .keys(clone)
    .filter(key => isPlainObject(clone[key]))
    .forEach((key) => {
      clone[key] = { ...clone[key] }
      // clone[key] = toClone(clone[key]) // recursive
    })

  return clone
}

export const toWithoutKeys = (removeKeys, isDeep = false) => (obj) => {
  const clone = { ...obj }

  removeKeys.forEach((key) => {
    delete clone[key]
  })

  if (isDeep) {
    const toWithoutKeysSelf = toWithoutKeys(removeKeys, isDeep)

    // array deep
    Object
      .keys(clone)
      .filter(key => Array.isArray(clone[key]))
      .forEach((key) => {
        clone[key] = clone[key].map(toWithoutKeysSelf)
      })

    // object deep
    Object
      .keys(clone)
      .filter(key => isPlainObject(clone[key]))
      .forEach((key) => {
        clone[key] = toWithoutKeysSelf(clone[key])
      })
  }

  return clone
}

// const toSum = (a, b) => (a || 0) + b

export const toSumByKey = key => (sum, obj) => sum + obj[key]

export const last = (obj) => {
  if (!obj) return null

  return isPlainObject(obj) ? last(Object.values(obj)) : obj[obj.length - 1]
}

export const deepMerge = (target, ...sources) => {
  if (!sources.length) return target
  const source = sources.shift()

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach((key) => {
      if (isPlainObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} })

        deepMerge(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    })
  }

  return deepMerge(target, ...sources)
}

export const range = (to, from = 0) => [...Array((to + 1) - from).keys()].map(x => x + from)

export const uniqueArray = arr => Array.from(new Set(castArray(arr)))

// export const toFrequencyMap = (acc, el) => {
//   if (!acc[el]) acc[el] = 0

//   acc[el] += 1

//   return acc
// }

// export const toMostFrequent = (acc, el, index, arr) =>
//   index === arr.length - 1
//     ? Object.keys(acc).sort((a, b) => b - a)[0]
//     : toFrequencyMap(acc, el)

// --------- Time ----------
export const VueDate = (time = null, ...args) => {
  if (isFunction(time)) {
    time = time(new Date())
  }

  if (!time) {
    time = new Date()
  } else if (time.obj) {
    return time
  }

  const date = new Date(time, ...args)
  return {
    year: date.getFullYear(),
    month: date.getMonth(),
    date: date.getDate(),
    hours: date.getHours(),
    minutes: date.getMinutes(),
    seconds: date.getSeconds(),
    milliseconds: date.getMilliseconds(),
    time: date.getTime(),
    obj: date,
    // toString: date.toString,
    // toISOString: date.toISOString,
    // toGMTString: date.toGMTString,
  }
}

export const toDateString = ({ year, month, date }) =>
  `${year ? year + '-' : ''}${pad(month + 1)}-${pad(date)}`

export const now = () => new Date().getTime()
export const months = [
  'Jan', 'Feb', 'Mar',
  'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep',
  'Oct', 'Nov', 'Dec',
]
export const weekdays =
  ['Sun', 'Mon', 'Tues', 'Wednes', 'Thurs', 'Fri', 'Satur'].map(x => `${x}day`)

// export const daysInMonth = obj => new Date(obj.getFullYear(), obj.getUTCMonth() + 1, 0).getDate()

// --------- Filtering ---------
// export const applyFilter = (filters, value) => {
//   if (!filters) return value

//   return castArray(filters)
//     .reduce((out, filterName) => Vue.filter(filterName)(out), value)
// }

// --------- Pagination (Dashboard) ---------
export const sort = (obj, fn) =>
  typeof obj.length !== 'undefined'
    ? obj.sort(fn)
    : Object.values(obj).sort(fn)

// dot path resolver
// ({a: {b: 1}}, 'a.b') => 1
export const dot = (obj, path) => path
  .split('.')
  .reduce((el, pointer, _, arr) => {
    if (typeof el !== 'object' || el === null) {
      arr.splice(1)
      return undefined
    }

    return el[pointer]
  }, obj)

export const prioritizeFunc = fn => (a, b) => {
  if (fn(a) || fn(b)) {
    if (fn(a)) {
      return -1
    }
    return 1
  }
  return 0
}

export const prioritizeSort = (byKey = null, value) => prioritizeFunc(el => el[byKey] === value)

export const prioritize = (arr, byKey, value) => [...arr].sort(prioritizeSort(byKey, value))

export const genPagination = overrides => ({
  name: null,

  // current pagination index (current state)
  page: 0,

  // display records per page
  perPage: 12,

  // string filter
  filter: '',

  filterIndex: 0,
  filterOptions: [
    {
      name: 'All',
      query: {},
    },
  ],

  sortIndex: 0,
  sortOptions: [
    {
      name: 'Latest first',
      sort: {
        createdAt: -1,
      },
    },
    {
      name: 'Oldest first',
      sort: {
        createdAt: 1,
      },
    },
  ],

  // custom query
  query: {},

  ...overrides,
})

// const doesPassFilter = (obj, filterBy) => {
//   const keys = Object.keys(obj)
//   for (const prop of keys) {
//     if (typeof obj[prop] === 'string') {
//       if (obj[prop].toLowerCase().indexOf(filterBy) !== -1) {
//         return true
//       }
//     } else if (isPlainObject(obj[prop])) {
//       if (doesPassFilter(obj[prop], filterBy)) {
//         return true
//       }
//     }
//   }
//   return false
// }

// const paginateFilter = (obj, filterBy) => {
//   if (!filterBy) {
//     return obj
//   }
//   const preparedFilter = filterBy.toLowerCase()
//   return filter(obj, row => doesPassFilter(row, preparedFilter))
// }

// const compare = (a, b) => {
//   if (typeof a === 'object' && a !== null) {
//     if (a.time) {
//       return compare(a.time, b.time)
//     }

//     if (typeof a.getTime === 'function') {
//       return compare(a.getTime(), b.getTime())
//     }
//   }

//   /* eslint-disable no-nested-ternary */
//   return a > b ? 1 : a < b ? -1 : 0
//   /* eslint-enable no-nested-ternary */
// }

// export const paginate = (data, options) => {
//   // const active = cols[Object.keys(cols)[options.col]]
//   // const limit = options.limit
//   // const order = options.asc ? 1 : -1
//   // const ref = active.ref

//   // TODO: add more advanced filtering
//   // if (options.filter !== '' && options.filter !== null) {
//   //   data = paginateFilter(data, options.filter)
//   // }

//   // data = sort(data, (a, b) => {
//   //   const c = dot(a, ref)
//   //   const d = dot(b, ref)

//   //   // TODO: a way to get rid of `undefined` check?
//   //   if (c === undefined) {
//   //     if (d === undefined) {
//   //       return 0
//   //     }
//   //     return order * -1
//   //   } else if (d === undefined) {
//   //     return order * 1
//   //   }

//   //   return order * compare(c, d)
//   // })

//   // pagination
//   options.total = data.length
//   if (data.length > options.perPage) {
//     const start = options.page * options.perPage
//     data = [...data].splice(start, options.perPage)
//   }

//   // limit
//   // if (limit > 0) {
//   //   data = data.splice(0, limit)
//   // }

//   return data
// }



// WEBPACK FOOTER //
// ./src/views/utils/index.js